import React, { useEffect, useState } from "react";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row, Label } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert"
import moment from 'moment'
import { CircularProgress } from "@material-ui/core";


const AddDeepLinkNavigation = (props) => {

  const [name,setName]= useState()
  const [navigation,setNavigation]= useState()
  const [successAlert,setSuccesAlert]=useState(false)
  const [errorAlert, setErrorAlert]=useState(false)
  const [errorMessage,setErrorMessage]=useState('')
  const [token, setToken] = useState()
  const [propsData, setProps] = useState(props?.location?.state)
  const [loader,setLoader]=useState(false)

  
  
  useEffect(()=>{
    const token = localStorage.getItem("AuthenticationToken")
    setToken(token)

if(props.location.state?.edit){
  setProps(props?.location?.state)
  var name = props.location.state?.item?.path_name
  var navigation = props.location.state?.item?.navigate_to
  setName(name)
  setNavigation(navigation)
}
  },[])

  const handleSubmit=()=>{
    if(!name){
      setErrorMessage('Please Enter Name')
      setErrorAlert(true)
      return
    }
    else if(!navigation){
      setErrorMessage('Please Enter Navigation')
      setErrorAlert(true)
      return
    }
    setLoader(true)

  let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm")
  var myHeaders= new Headers()
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append("Cookie", "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208");

    var formdata =new FormData();
    formdata.append("path", "deeplink/add");
    formdata.append('path_name',name)
    formdata.append('navigate_to',navigation)
    formdata.append('created_datetime',currentDate)
    formdata.append('item_type',"deeplink")

   var requestOptions={
    method: 'POST',
    headers: myHeaders,
    body: formdata,
    redirect: 'follow',
    processData: false,
    mimeType: "multipart/form-data",
    async: true,
    crossDomain: true,
    }

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`,requestOptions).then((response)=>{
      if (response.status == 200) {
        console.log("here is the res",response)
        setSuccesAlert(true)
        setLoader(false)
      } else {
        setErrorMessage("Unable to Add")
        setErrorAlert(true)
        setLoader(false)
      }
      response.json()
      console.log("here is the res",response)
    }).catch((error)=>{
       console.log("here come error--->",error)
    })
  }
  const handleEdit=()=>{
    console.log("Now Edit is called---->")
    if(!name){
      setErrorMessage('Please Enter Name')
      setErrorAlert(true)
      return
    }
    else if(!navigation){
      setErrorMessage('Please Enter Navigation')
      setErrorAlert(true)
      return
    }

    setLoader(true)

  // let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm")
  var myHeaders= new Headers()
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append("Cookie", "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208");

    var formdata =new FormData();
    formdata.append("path", "deeplink/update");
    formdata.append("item_id", propsData?.item?.item_id);
    formdata.append('path_name',name)
    formdata.append('navigate_to',navigation)
    formdata.append('item_type',"deeplink")

   var requestOptions={
    method: 'POST',
    headers: myHeaders,
    body: formdata,
    redirect: 'follow',
    processData: false,
    mimeType: "multipart/form-data",
    async: true,
    crossDomain: true,
    }

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`,requestOptions).then((response)=>{
      if (response.status == 200) {
        console.log("here is the res",response)
        setSuccesAlert(true)
        setLoader(false)
      } else {
        setErrorMessage("Unable to Add")
        setErrorAlert(true)
        setLoader(false)
      }
      console.log("here is the res",response)
    }).catch((error)=>{
       console.log("here come error--->",error)
    })
  }

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          props?.history.push('/deeplink-navigation')
        }}
        onConfirm={() => {
          props?.history.push('/deeplink-navigation')
          setSuccesAlert(false)
          setLoader(false)
        }}
        onCancel={() => {
          setSuccesAlert(false)
        }}
      >
        {"Deeplink Navigation Added"}
        </SweetAlert>
    )
  }

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false)
          setLoader(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    )
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            breadcrumbItem="DeepLink Navigation"
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Row>
                      <Col lg={4} md={6} sm={6}>
                        <div className="mb-3">
                          <Label>Name</Label>
                          <div className="col-md-12">
                            <input
                              className="form-control"
                              type="text"
                              id="name_input"
                              onChange={(e)=>{
                                setName(e.target.value)
                              }}
                              defaultValue={name}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Col lg={6} md={6} sm={6}>
                      <div className="mb-3">
                        <Label>Navigate To</Label>
                        <div className="col-md-12">
                          <textarea
                              rows="4" 
                              cols="33"
                            className="form-control"
                            type="text"
                            id="navigation-input"
                            onChange={(e)=>setNavigation(e.target.value)}
                            defaultValue={navigation}
                          />
                        </div>
                      </div>
                    </Col>
                    <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/deeplink-navigation");
                        }}
                        color="danger"
                        type="submit"
                      >
                        {" "}
                        Cancel
                      </Button>
                      <button
                       disabled={loader}
                       style={{color:"#ffffff", width:"80px",marginLeft: "10px"}}
                       className={ "btn btn-success"}
                        onClick={() => {
                          if (props?.location?.state?.edit) {
                            handleEdit();
                          } else {
                            handleSubmit();
                          }
                        }}
                        // className="px-4"
                        color="success"
                        type="submit"
                      >
                       {loader ? <CircularProgress 
                                size={15}
                                value={100}
                                color={"white"} />
                              : "Save"}
                      </button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert?renderSuccessAlert():null}
          {errorAlert?renderFailureAlert():null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddDeepLinkNavigation;

